<template>
  <v-card  :color=" this.$vuetify.theme.dark ? '#121212' : '#fff'"
    outlined elevation="2" shaped>

    <v-card-title>
      <v-row class="gy-0">
        <v-col cols="3" sm="2" v-if="isManager || isTeacher">
          <v-text-field label="Id" v-model="account.accountId" flat   readonly/>
        </v-col>
        <v-col cols="4" sm="4" v-if="isManager || isTeacher">
          <v-text-field label="User Name" v-model="account.username"  :readonly="!isManager" flat/>
        </v-col>
        <v-col cols="4" sm="4" v-if="isManager || isTeacher">
          <v-text-field label="English Name" v-model="account.englishName"  :readonly="!isManager" flat/>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col cols="12" sm="4">
          <v-img :src="account.profileImageUrl" max-width="200px" width="200px" height="190px"  />
          <v-file-input v-if="isManager || isTeacher"
                        label="Profile Image"
                        variant="filled"
                        prepend-icon="mdi-camera"
                        @change="selectFile"
          />
        </v-col>
        <v-col v-if="isManager || isTeacher" cols="12" sm="8">
          <v-row class="gy-0">
            <v-col v-if="isManager" cols="6" sm="6" >
              <v-text-field label="Phone" v-model="account.phone" dense/>
            </v-col>
            <v-col v-if="isManager" cols="6" sm="6">
              <v-text-field label="Email" v-model="account.email" dense/>
            </v-col>
            <v-col v-if="isTeacher || isManager" cols="6" sm="6">
              <v-text-field label="Zoom Id" v-model="account.accountInfo.zoomId" dense/>
            </v-col>
            <v-col v-if="isTeacher || isManager" cols="6" sm="6">
              <v-text-field label="Teams Id" v-model="account.accountInfo.skypeId" dense/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text>
<!--      v-if="isShowTeacherInfo"-->
      <v-row>
        <v-col cols="12" sm="4">
          <div v-show="account.accountInfo.major"><strong>Major</strong> <br>  {{  account.accountInfo.major }}</div>
          <v-text-field v-if="isTeacher || isManager" v-show="account.accountInfo.major" label="Major" v-model="account.accountInfo.major"/>
        </v-col>
        <v-col cols="12" sm="4">
          <div v-show="account.accountInfo.country"><strong>Country</strong> <br>  {{  account.accountInfo.country }}</div>
          <v-text-field v-if="isTeacher || isManager" label="Country" v-model="account.accountInfo.country" dense/>
        </v-col>
        <v-col cols="12" sm="4">
          <div v-show="account.accountInfo.personality" ><strong>Personality</strong> <br>  {{  account.accountInfo.personality }}</div>
          <v-text-field v-if="isTeacher || isManager" label="Personality" v-model="account.accountInfo.personality"/>
        </v-col>
        <v-col cols="12" sm="12">
          <div v-show="account.accountInfo.career"> <strong>Career</strong> <br> {{ account.accountInfo.career }}</div>
          <v-text-field v-if="isTeacher || isManager"  label="Career"       v-model="account.accountInfo.career" dense/>        </v-col>
        <v-col cols="12" sm="12">
          <div v-show="account.accountInfo.intro"><strong>Intro</strong> <br> {{ account.accountInfo.intro }}</div>
          <v-text-field v-if="isTeacher || isManager"  label="Intro" v-model="account.accountInfo.intro" dense/>
        </v-col>
        <!--      <v-textarea label="Career" v-model="account.accountInfo.career"/>-->
        <!--      <v-textarea label="Intro" v-model="account.accountInfo.intro"/>-->
      </v-row>
    </v-card-text>
    <v-card-text>
      <v-chip v-if="isTeacher || isManager" v-show="isConnectedKakao" color="yellow" text-color="black" >Kakao</v-chip>
      <v-chip v-if="isTeacher || isManager" v-show="isConnectedGoogle" color="white" text-color="black" >Google</v-chip>
      <v-chip v-if="isTeacher || isManager" v-show="isConnectedNaver" color="green" text-color="white" >Naver</v-chip>
    </v-card-text>

<!--        <v-col cols="12" >-->
<!--          <v-row v-if="isStudent || isManager">-->
<!--            &lt;!&ndash;                  <v-col v-if="!isConnectedKakao" cols="12" md="6">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <v-btn @click="loginOAuth2('kakao')" width="200" height="50">&ndash;&gt;-->
<!--            &lt;!&ndash;                      <img type="button" width="195" height="45"&ndash;&gt;-->
<!--            &lt;!&ndash;                           src="https://do-en9door-s3.sgp1.cdn.digitaloceanspaces.com/website/button/btn_kakao_signin_light.png"/>&ndash;&gt;-->
<!--            &lt;!&ndash;                    </v-btn>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </v-col >&ndash;&gt;-->
<!--            &lt;!&ndash;                  <v-col v-if="!isConnectedGoogle" cols="12" md="6">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <v-btn  width="200" height="50">&ndash;&gt;-->
<!--            &lt;!&ndash;                      <GoogleLogin :params="params"&ndash;&gt;-->
<!--            &lt;!&ndash;                                   :onSuccess="onGoogleLoginSuccess"&ndash;&gt;-->
<!--            &lt;!&ndash;                                   :onFailure="onGoogleLoginFailure">&ndash;&gt;-->
<!--            &lt;!&ndash;                        <img type="button" width="200" height="50"&ndash;&gt;-->
<!--            &lt;!&ndash;                             src="https://do-en9door-s3.sgp1.cdn.digitaloceanspaces.com/website/button/btn_google_signin_light.png"/>&ndash;&gt;-->
<!--            &lt;!&ndash;                      </GoogleLogin>&ndash;&gt;-->
<!--            &lt;!&ndash;                    </v-btn>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </v-col>&ndash;&gt;-->
<!--          </v-row>-->
<!--        </v-col>-->

    <v-card-actions class="justify-end" v-if="isManager || isTeacher">
      <v-btn class="btn-sm" color="primary" small
             @click="saveUser()">Save(저장)
      </v-btn>
      <slot>

      </slot>
    </v-card-actions>
  </v-card>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import apiAccount from "@/api/modules/api-account";
import apiPublicAccount from "@/api/public-modules/api-account";

export default {
  name: 'CardAccount',
  components: {  },
  props: {
    selectedAccountId: {type: Number},
    isShowPersonalInfo: {type: Boolean, default: false},
  },
  data(){
    return {
      profileImage: {},
      profileImageUrl: '',
      listLoading: true,
      account: {
        accountInfo: {
          infro: '',
          career: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters(['app','user', 'isStudent', 'isTeacher', 'isManager']),
    isConnectedKakao : function (){
      return this.account.accountSnsList.filter(acs => acs.providerType === 'KAKAO').length === 1
    },
    isConnectedGoogle : function (){
      return this.account.accountSnsList.filter(acs => acs.providerType === 'GOOGLE').length === 1
    },
    isConnectedNaver : function (){
      return this.account.accountSnsList.filter(acs => acs.providerType === 'NAVER').length === 1
    },
    isShowTeacherInfo: function (){
      return (this.isTeacher || this.isManager)
    }
  },
  created() {
    this.profileImageUrl = this.account.profileImageUrl
    if (!this.account.zoomId){
      this.account.zoomId = this.account.email
    }
  },
  beforeMount() { },
  mounted() {
    this.getAccount()
  },
  methods: {
    ...mapActions(['fetchUser', 'updateSelectedUser','saveAccountInfo','saveAccountProfile', 'saveAccountProfileImage']),

    saveUser(){
      this.account.accountInfo.accountId = this.account.accountId

      let resSaveAccount = apiAccount.putUserById(this.account)
          .then(res => this.account = res)

      let resSaveAccountInfo = apiAccount.saveAccountInfo(this.account.accountInfo)
          .then(res => this.account.accountInfo = res)
          .catch(() => this.account.accountInfo = {})

      if(this.account.profileImageFile){
        const formData = new FormData();
        formData.append("profileImage", this.account.profileImageFile);

        apiAccount.saveProfileImg(this.account.accountId, formData)
            .then(res => this.account.profileImageFile = res)
      }

      Promise.any([resSaveAccount, resSaveAccountInfo])
          .then(() => this.$emit('saveUser', this.account))
          .then(() => this.$dialog.notify.info('Success', {position: 'top-right',timeout: 1000}))
          .catch((err) => this.$dialog.notify.error(err.message, {position: 'top-right',timeout: 1000}))
    },
    async getAccount(){
      if (this.isStudent || this.isTeacher || this.isManager) {
        await apiAccount.getUserById(this.selectedAccountId)
            .then(res => {
              this.account = res
              this.account.accountInfo = res.accountInfo
              return res
            })
            .catch((err) => this.$dialog.notify.error(err.message, {position: 'top-right',timeout: 1000}))

        // await apiAccount.getAccountInfo(this.selectedAccountId)
        //     .then(res => {
        //       this.account.accountInfo = res
        //       return res
        //     })
        //     .catch((err) => this.$dialog.notify.error(err.message, {position: 'top-right',timeout: 1000}))
      } else {
        await apiPublicAccount.getTeacherById(this.selectedAccountId)
            .then(res => {
              this.account = res
              return res
            })
      }
    },
    selectFile(file) {
      this.profileImage = file
      this.account.profileImageFile = file
      this.account.profileImageUrl = URL.createObjectURL(file)
    },
  },

}
</script>
